{
	"type": "line",
	"minzoom": 1,
	"layout": {},
	"paint": {
		"line-color": "#aaacaf",
		"line-width": ["interpolate", ["linear"], ["zoom"], 1, 0.2, 9, 0.7, 18, 5],
		"line-opacity": 0.8
	}
}
